import { Helmet } from 'react-helmet';
import { useRef, useState, useContext } from 'react';
import { useNavigate } from 'react-router';
import styles from './index.module.scss';
import { useAuth } from 'context/Auth'; 
import { chkOtherUser } from 'api/return'; 
import { GlobalContext } from "../../storage"; 
// import { useGlobalError } from 'context/Error/GlobalErrorContext';
import Dialog from "components/Dialog";

const ReturnForOther = () => {
  const [phone, setPhone] = useState<string>();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const navigate = useNavigate();
  const { accessToken} = useAuth(); 
  const { returnStorage } = useContext(GlobalContext); 
  // eslint-disable-next-line
  const { renter_id, setRenterId } = returnStorage; 
  // const { showError } = useGlobalError()
  const [repeatVisible, setRepeatVisible] = useState<boolean>(false);//重複歸還提醒
  const [mess, setMess] = useState<string>('');
  

  const fetchOtherUser = async () => {
    try {
      const { data } = await chkOtherUser(accessToken!, 1, {
        mobile_number: phone,
      });
      if(data){
        setRenterId(data?.id);
        handleNext();
      }
    } catch (e: any) {
      console.log(e);
      // const error = e.response.data.message
      const errCode = e.response.status
      // showError(error, 'error')
      if(errCode === 422){
        setMess('手機格式錯誤')
      }
      if(errCode === 404){
        setMess('查無此手機號碼的會員，請確認號碼是否正確')
      }
      if(errCode === 500){
        setMess('伺服器錯誤')
      }
      setRepeatVisible(true)
    }
  };

  const handleNext = () => {

    navigate('/return', {
      state: {
        phone,
      },
    });
  };


  return (
    <>
      <Helmet title="我幫別人還" />
      <div className={styles.returnForOther}>
        <h5>請輸入循環包裝使用者的手機號碼</h5>
        <h6>請確保號碼輸入正確，以利後續歸還作業</h6>
        <input
          type="tel"
          pattern="[0-9]*"
          ref={inputRef}
          onChange={(event) => {
            setPhone(event.target.value as any);
          }}
        />
        <button
          onClick={() => {
            fetchOtherUser();
            // handleNext();
          }}
        >
          下一步
        </button>
      </div>
      <Dialog
        visible={repeatVisible}
        // visible={true}
        onConfirm={()=>{setRepeatVisible(false)}}
        message={
          <div className={styles.dialogHeader}>
            <h5>提醒</h5>
            <p>
              {mess}
              <br />
            </p>
          </div>
        }
        showOk={true}
      />
    </>
  );
};

export default ReturnForOther;
